import {gsap} from '../shared/gsap';

const $ = jQuery.noConflict();

'use strict';
/**
 * @description Draws SVG paths with GSAP's DrawSVGPlugin as their section scrolls into view.
 * @description Any section with `.js-animated-path` is auto-detected; the SVG wrapper inside it needs `.js-animate`.
 * #description Parent class : js-animated-path
 * #description SVG class : js-animate
 * @example <section class="js-animated-path"><div class="js-animate"><svg><path/></svg></div></section>
 * @example Options (data attributes on `.js-animated-path`): data-animate-threshold="0.45" data-animate-once="false" data-animate-reverse="true" data-animate-duration="2000"
 */
const AnimatePath = {

	/** @description Initialize */
	init: function() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		this.cacheDOM();
		this.setup();
	},

	cacheDOM: function() {
		this.$sections = $('.js-animated-path');
	},

	setup: function() {
		this.$sections.each((index, section) => this.setupSection($(section)));
	},

	setupSection: function($section) {
		const $paths = $section.find('.js-animate svg path');

		if (!$paths.length) {
			return;
		}

		const once = $section.data('animate-once') !== false;
		const reverse = String($section.data('animate-reverse')) === 'true';
		const threshold = parseFloat($section.data('animate-threshold')) || 0.45;
		const duration = (parseFloat($section.data('animate-duration')) || 1600) / 1000;

		// mirrors the previous rootMargin math: the section starts drawing once its
		// top crosses this percentage down the viewport, instead of waiting for a
		// percentage of the section itself to be visible
		const start = 'top ' + Math.round((1 - threshold) * 100) + '%';

		gsap.set($paths.toArray(), {drawSVG: reverse ? '100% 100%' : '0%'});

		gsap.to($paths.toArray(), {
			drawSVG: reverse ? '0% 100%' : '100%',
			duration: duration,
			ease: 'power1.inOut',
			stagger: 0.1,
			scrollTrigger: {
				trigger: $section.get(0),
				start: start,
				toggleActions: once ? 'play none none none' : 'play reverse play reverse',
			},
		});
	},

};

export default AnimatePath;
